import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/common/UIKit";

export default function PrivacyPolicyPage() {
  return (
    <main className="min-h-screen bg-white text-zinc-950">
      <section className="border-b border-zinc-200/80 bg-gradient-to-b from-white to-zinc-50/80">
        <div className="mx-auto flex w-full max-w-4xl flex-col gap-3 px-4 py-5 sm:px-6 lg:px-8">
          <Link to="/" className="w-fit">
            <Button variant="ghost" className="h-9 px-3 text-sm hover:bg-zinc-100">
              <ArrowLeft className="mr-2 h-4 w-4" /> Back to home
            </Button>
          </Link>
          <div className="space-y-1">
            <h1
              className="max-w-3xl text-3xl font-black tracking-tight text-zinc-950 sm:text-4xl"
              style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            >
              Terms of Use
            </h1>
            <p className="text-sm text-zinc-500">
              <strong>Effective Date:</strong> May 13, 2026
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto flex w-full max-w-4xl flex-col gap-6 px-4 py-8 sm:px-6 lg:px-8">
        <article className="rounded-3xl border border-zinc-200 bg-white p-6 shadow-sm sm:p-8 text-base text-zinc-700 leading-7">
          <p className="mb-6 text-zinc-600">
            Welcome to <strong>ProbateDivorce.com</strong>. This website is owned and operated by{" "}
            <strong>ProbateDivorce Inc.</strong> By accessing or using our platform, you agree to
            comply with and be bound by the following terms and conditions.
          </p>

          <section className="space-y-6">
            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">1. Nature of Services</h2>
              <p className="mt-3 text-zinc-600">
                ProbateDivorce Inc. operates as a <strong>lead generation and referral platform</strong>.
              </p>
              <ul className="mt-3 list-disc space-y-2 pl-6 text-zinc-600">
                <li>We connect users seeking assistance with probate or divorce matters to third-party professionals (e.g., attorneys, real estate agents, or financial advisors).</li>
                <li><strong>We are not a law firm.</strong> We do not provide legal, financial, or tax advice.</li>
                <li>Any information provided on this site is for educational purposes only and does not constitute an attorney-client relationship.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">2. No Guarantee of Results</h2>
              <p className="mt-3 text-zinc-600">While we strive to connect you with qualified professionals, ProbateDivorce Inc.:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6 text-zinc-600">
                <li>Does <strong>not</strong> endorse or warrant the quality of work of any third-party professional.</li>
                <li>Is <strong>not</strong> responsible for the outcome of any legal or real estate matter.</li>
                <li>Does <strong>not</strong> guarantee that a professional will accept your case or respond to your inquiry.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">3. Consent to Contact</h2>
              <p className="mt-3 text-zinc-600">By submitting your contact information through our lead forms, you expressly consent to:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6 text-zinc-600">
                <li>Being contacted by <strong>ProbateDivorce Inc.</strong> and its network of third-party professionals.</li>
                <li>Receiving communications via email, SMS, or telephone (including automated dialing systems), even if your number is on a "Do Not Call" registry.</li>
                <li>The sharing of your submitted data with relevant third parties to facilitate the referral process.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">4. User Responsibilities</h2>
              <p className="mt-3 text-zinc-600">As a user of this platform, you agree to:</p>
              <ul className="mt-3 list-disc space-y-2 pl-6 text-zinc-600">
                <li>Provide accurate, current, and complete information.</li>
                <li>Use the services only for lawful purposes.</li>
                <li>Acknowledge that the final selection of any professional is your sole responsibility.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">5. Limitation of Liability</h2>
              <p className="mt-3 text-zinc-600">
                To the maximum extent permitted by law, <strong>ProbateDivorce Inc.</strong> shall not
                be liable for any direct, indirect, incidental, or consequential damages resulting from:
              </p>
              <ol className="mt-3 list-decimal space-y-2 pl-6 text-zinc-600">
                <li>Your use of the platform.</li>
                <li>The acts or omissions of any third-party professional referred through our site.</li>
                <li>Any technical inaccuracies or typographical errors on the website.</li>
              </ol>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">6. Third-Party Links</h2>
              <p className="mt-3 text-zinc-600">Our website may contain links to external sites. We do not control these sites and are not responsible for their content, privacy policies, or business practices.</p>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">7. Intellectual Property</h2>
              <p className="mt-3 text-zinc-600">
                All content, logos, and branding on <strong>ProbateDivorce.com</strong> are the property
                of <strong>ProbateDivorce Inc.</strong> and are protected by copyright and trademark laws.
                You may not reproduce or distribute any content without our prior written consent.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">8. Modifications to Terms</h2>
              <p className="mt-3 text-zinc-600">We reserve the right to update these Terms of Use at any time. Your continued use of the site after changes are posted constitutes your acceptance of the new terms.</p>
            </div>

            <div>
              <h2 className="text-xl font-black tracking-tight text-zinc-950 sm:text-2xl">9. Governing Law</h2>
              <p className="mt-3 text-zinc-600">
                These terms are governed by and construed in accordance with the laws of the State in
                which <strong>ProbateDivorce Inc.</strong> is incorporated, without regard to its conflict
                of law principles.
              </p>
            </div>
          </section>
        </article>
      </section>
    </main>
  );
}